import React from 'react';
import styled from 'styled-components';
import { Icon, Tooltip } from 'antd';

const Card = styled.div`
  background: white;
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  flex: 1;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid ${props => props.isActive ? props.color : 'transparent'};
  position: relative;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
`;

const Title = styled.div`
  font-size: 14px;
  color: ${props => props.isActive ? props.color : '#8c8c8c'};
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Value = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: ${props => props.isActive ? props.color : '#262626'};
`;

const Percentage = styled.div`
  font-size: 12px;
  color: ${props => props.color || '#8c8c8c'};
  position: absolute;
  top: 16px;
  right: 16px;
`;

const IconsContainer = styled.div`
  display: flex;
  gap: 8px;
  position: absolute;
  bottom: 16px;
  right: 16px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #8c8c8c;
`;

const InfoIcon = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  color: #8c8c8c;
`;

const getIcon = (status) => {
  switch (status) {
    case 'draft':
      return <Icon type="file" style={{ color: '#8c8c8c' }} />;
    case 'pendent':
      return <Icon type="mail" style={{ color: '#1890ff' }} />;
    case 'delivered':
      return <Icon type="mail" style={{ color: '#52c41a' }} />;
    case 'opened':
      return <Icon type="eye" style={{ color: '#722ed1' }} />;
    case 'clicked':
      return <Icon type="link" style={{ color: '#faad14' }} />;
    case 'failed':
      return <Icon type="exclamation-circle" style={{ color: '#f5222d' }} />;
    default:
      return <Icon type="mail" style={{ color: '#8c8c8c' }} />;
  }
};

const getTitle = (status) => {
  switch (status) {
    case 'draft':
      return 'Rascunho';
    case 'pendent':
      return 'Envio Solicitado';
    case 'delivered':
      return 'Enviado';
    case 'opened':
      return 'Aberto';
    case 'clicked':
      return 'Clicado';
    case 'failed':
      return 'Não enviado';
    default:
      return status;
  }
};

const getCardDescription = (status) => {
  switch (status) {
    case 'draft':
      return 'E-mail salvo como rascunho, ainda não enviado';
    case 'pendent':
      return 'E-mail aguardando envio';
    case 'delivered':
      return 'E-mail entregue ao servidor do destinatário';
    case 'opened':
      return 'Destinatário abriu o e-mail';
    case 'clicked':
      return 'Destinatário clicou em algum link do e-mail';
    default:
      return '';
  }
};

const SummaryCard = ({ status, count, total, color, isActive, onClick, failedCounts }) => (
  <Card isActive={isActive} color={color} onClick={onClick}>
    {total > 0 && (
      <Percentage color={color}>
        {((count / total) * 100).toFixed(1)}%
      </Percentage>
    )}
    <Title isActive={isActive} color={color}>
      {getIcon(status)}
      {getTitle(status)}
    </Title>
    <Value isActive={isActive} color={color}>{count}</Value>
    {status === 'failed' ? (
      <IconsContainer>
        <Tooltip title={
          <div>
            <div>Falhou: {failedCounts.failed || 0}</div>
            <div style={{ color: '#8c8c8c', fontSize: '12px' }}>E-mail não foi entregue ao destinatário</div>
          </div>
        }>
          <IconWrapper>
            <Icon type="exclamation-circle" />
          </IconWrapper>
        </Tooltip>
        <Tooltip title={
          <div>
            <div>Blacklist: {failedCounts.blacklist || 0}</div>
            <div style={{ color: '#8c8c8c', fontSize: '12px' }}>E-mail bloqueado pelo provedor</div>
          </div>
        }>
          <IconWrapper>
            <Icon type="stop" />
          </IconWrapper>
        </Tooltip>
        <Tooltip title={
          <div>
            <div>Inscrição cancelada: {failedCounts.unsubscribed || 0}</div>
            <div style={{ color: '#8c8c8c', fontSize: '12px' }}>Destinatário cancelou a inscrição</div>
          </div>
        }>
          <IconWrapper>
            <Icon type="user-delete" />
          </IconWrapper>
        </Tooltip>
        <Tooltip title={
          <div>
            <div>Marcado como spam: {failedCounts.complained || 0}</div>
            <div style={{ color: '#8c8c8c', fontSize: '12px' }}>Destinatário marcou como spam</div>
          </div>
        }>
          <IconWrapper>
            <Icon type="warning" />
          </IconWrapper>
        </Tooltip>
        <Tooltip title={
          <div>
            <div>Duplicado: {failedCounts.duplicated || 0}</div>
            <div style={{ color: '#8c8c8c', fontSize: '12px' }}>E-mail duplicado detectado</div>
          </div>
        }>
          <IconWrapper>
            <Icon type="copy" />
          </IconWrapper>
        </Tooltip>
      </IconsContainer>
    ) : (
      <InfoIcon>
        <Tooltip title={getCardDescription(status)}>
          <Icon type="info-circle" />
        </Tooltip>
      </InfoIcon>
    )}
  </Card>
);

export default SummaryCard; 